/* eslint-disable no-param-reassign */
import qs from 'qs'
import { platform } from '@/utils/platform'
import { detectEnvironment, getEvnBaseUrl } from '@/utils'
import { useUserStore } from '@/store/user'

export type CustomRequestOptions = UniApp.RequestOptions & {
  query?: Record<string, any>
  /** 出错时是否隐藏错误提示 */
  hideErrorToast?: boolean
  token?: string
} & IUniUploadFileOptions // 添加uni.uploadFile参数类型

// 请求基准地址
const baseUrl = getEvnBaseUrl()

/**
 * 页面级请求头覆盖（例如发布页透传小程序宿主的 `platform/os/version/deviceid/brand`）。
 * 只保存本次会话的参数，不做持久化；不传时保持既有默认头。
 */
export const requestHeaderOverrides: Record<string, string> = {}

export function setRequestHeaderOverrides(headers: Record<string, string | undefined>) {
  for (const key of Object.keys(requestHeaderOverrides)) {
    delete requestHeaderOverrides[key]
  }
  for (const [key, value] of Object.entries(headers)) {
    if (value) requestHeaderOverrides[key] = value
  }
}

// 拦截器配置
const httpInterceptor = {
  // 拦截前触发
  invoke(options: CustomRequestOptions) {
    // 接口请求支持通过 query 参数配置 queryString
    if (options.query) {
      const queryStr = qs.stringify(options.query)
      if (options.url.includes('?')) {
        options.url += `&${queryStr}`
      } else {
        options.url += `?${queryStr}`
      }
    }
    // 非 http 开头需拼接地址
    if (!options.url.startsWith('http')) {
      // #ifdef H5
      // console.log(__VITE_APP_PROXY__)
      if (JSON.parse(__VITE_APP_PROXY__)) {
        // 啥都不需要做
      } else {
        options.url = baseUrl + options.url
      }
      // #endif
      // 非H5正常拼接
      // #ifndef H5
      options.url = baseUrl + options.url
      // #endif
      // TIPS: 如果需要对接多个后端服务，也可以在这里处理，拼接成所需要的地址
    }
    // 1. 请求超时
    options.timeout = 30 * 1000
    // 2. （可选）添加小程序端请求头标识
    let payPlatform = 'h5'
    if (detectEnvironment().env === 'wechat') {
      payPlatform = 'wechat_h5'
    }
    options.header = {
      platform, // 可选，与 uniapp 定义的平台一致，告诉后台来源
      'pay-platform': payPlatform,
      version: '2.3.11',
      versionCode: '2031100',
      ...options.header,
      // 发布页由小程序宿主打开时，设备头要透传宿主的值：后端会按请求头更新用户设备状态，
      // 固定发 h5 会把用户的设备/平台记录写坏（`setRequestHeaderOverrides` 负责写入）。
      ...requestHeaderOverrides,
      // 最外层仍允许单次请求显式覆盖
      ...(options.header ?? {}),
    }
    // 3. 添加 token 请求头标识
    // const { token } = options
    const token = useUserStore().token
    if (token) {
      options.header.Authorization = `Bearer ${token}`
    }
  },
}

export const requestInterceptor = {
  install() {
    // 拦截 request 请求
    uni.addInterceptor('request', httpInterceptor)
    // 拦截 uploadFile 文件上传
    uni.addInterceptor('uploadFile', httpInterceptor)
  },
}
